import { routePaths } from '../../../routePaths';
import { translate } from '../../../utils';
import { WarehousePermission } from '../../../generated/graphql';
import { RouteType } from '../../../types';
import { CurrentInventoryCount, InventoryCountDetails, InventoryCounts } from '../../../modules/warehouse/components';

const WarehouseInventoryCountRoute: RouteType = {
    exact: false,
    showInSideBar: true,
    path: routePaths.inventoryCounts,
    title: translate('Inventory counts'),
    permissions: {
        warehouse: [WarehousePermission.CanViewInventoryCount],
    },
    component: InventoryCounts,
    childrenRoutes: [
        {
            exact: true,
            title: translate('Inventory count'),
            path:routePaths.currentInventoryCount,
            component: CurrentInventoryCount,
        },
        {
            title: translate('Inventory Count Details'),
            path:routePaths.inventoryCountsDetail,
            component: InventoryCountDetails,
        },
    ],
};

export default WarehouseInventoryCountRoute;
